export const USER_ROLE = {
  ADMIN: 'ADMIN',
  LEAD: 'LEAD',
  GUEST: 'GUEST',
};
